import React from "react";

const steps = [
  {
    id: "sign-up",
    label: "Sign up from page",
    icon: "/assets/images/signup/company-info-black",
    activeIcon: "/assets/images/signup/company-info-white.png",
  },
  {
    id: "number-verify",
    label: "Mobile Authentication OTP",
    icon: "/assets/images/signup/auth-otp-black.png",
    activeIcon: "/assets/images/signup/auth-otp-white.png",
  },
  {
    id: "create-number",
    label: "Select Number",
    icon: "/assets/images/signup/select-number-black.png",
    activeIcon: "/assets/images/signup/select-number-white.png",
  },
  {
    id: "select-package",
    label: "Package and Payments",
    icon: "/assets/images/signup/payment-black.png",
    activeIcon: "/assets/images/signup/payment-white.png",
  },
  {
    id: "order-page",
    label: "Verify Account",
    icon: "/assets/images/signup/verify-account-black.png",
    activeIcon: "/assets/images/signup/verify-account-black.png",
  },
];

function ProgressBar(props) {
  const { active } = props;
  const activeIndex = steps.findIndex((step) => step.id === active);
  return (
    <>
      <div className="mt-5 mb-3 text-center">
        <h1 className="font--40 text--black-191b fw--500 ">
          Get your business landline instantly
        </h1>
      </div>

      <ul className="step stepIcons d-flex flex-nowrap ">
        {steps.map((step, index) => {
          const isActive = index <= activeIndex;
          return (
            <li className={`step-item ${isActive ? "active" : ""}`}>
              <a
                href={void 0}
                className={`position-relative d-flex align-items-center justify-content-center font--14 ${
                  isActive ? "text--black" : ""
                }`}
              >
                <span
                  className={`h--40 w--40  position-absolute Iconcircle radius--50 d-flex justify-content-center align-items-center border--1 bg-white ${
                    isActive ? "bg--orange border--orange" : ""
                  }`}
                >
                  <img src={isActive ? step.activeIcon : step.icon} alt={step.id} />
                </span>
                {step.label}
              </a>
            </li>
          );
        })}
      </ul>

      {/* <ul className="step stepIcons d-flex flex-nowrap ">
        <li className={`step-item ${active === "sign-up" ? "active" : ""}`}>
          <a
            href={void 0}
            className="position-relative d-flex align-items-center justify-content-center text--black font--14"
          >
            <span className="h--40 w--40 bg--orange position-absolute Iconcircle radius--50 d-flex justify-content-center align-items-center border--1 border--orange">
              <img
                src={"/assets/images/signup/shopping-bag-01.png"}
                alt="abc"
              />
            </span>
            Sign up from page
          </a>
        </li>
        <li
          className={`step-item ${active === "number-verify" ? "active" : ""}`}
        >
          <a
            href={void 0}
            className="position-relative d-flex align-items-center justify-content-center"
          >
            <span className="h--40 w--40 bg--white position-absolute Iconcircle radius--50 d-flex justify-content-center align-items-center border--1 border--gray-ea">
              <img src={"/assets/images/signup/starBag.png"} alt="abc" />
            </span>
            Mobile Authentication-OTP
          </a>
        </li>

        <li
          className={`step-item ${active === "create-number" ? "active" : ""}`}
        >
          <a
            href={void 0}
            className="position-relative d-flex align-items-center justify-content-center"
          >
            <span className="h--40 w--40 bg--white position-absolute Iconcircle radius--50 d-flex justify-content-center align-items-center border--1 border--gray-ea">
              <img src={"/assets/images/signup/book.png"} alt="abc" />
            </span>
            Select Number
          </a>
        </li>
        <li
          className={`step-item ${active === "select-package" ? "active" : ""}`}
        >
          <a
            href={void 0}
            className="position-relative d-flex align-items-center justify-content-center"
          >
            <span className="h--40 w--40 bg--white position-absolute Iconcircle radius--50 d-flex justify-content-center align-items-center border--1 border--gray-ea">
              <img src={"/assets/images/signup/coins-hand.png"} alt="abc" />
            </span>
            Package and Payments
          </a>
        </li>
        <li className={`step-item ${active === "order-page" ? "active" : ""}`}>
          <a
            href={void 0}
            className="position-relative d-flex align-items-center justify-content-center"
          >
            <span className="h--40 w--40 bg--white position-absolute Iconcircle radius--50 d-flex justify-content-center align-items-center border--1 border--gray-ea">
              <img src={"/assets/images/signup/file-check-02.png"} alt="abc" />
            </span>
            Verify Account
          </a>
        </li>
      </ul> */}
    </>
  );
}

export default ProgressBar;
